import { Button, Card, CardActions, CardContent, LinearProgress, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { commons } from '../../commons';
import { formToObj, validateFormData } from '../../lib/validator';
import AuthService from '../../service/AuthService';
import { customStyles } from "../../styles/tableStyle"
import { userProfile } from '../../schema/formSchema/userProfile';
import { FormGenerator } from '../../lib';
import { appMessages } from '../../constants/appMessages';
import { SnackBarWidget } from '../../Widget';

function UserProfile(props) {
  const [loginData, setLoginData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    loadForm()
  }, []);



  const loadForm = async () => {
    let loginSchemaData = [...userProfile];
    loginSchemaData.map((item, index) => {
      loginSchemaData[index].value = props.user[item.key]
      if (item.key == "email") loginSchemaData[index].disabled = true
    })
    setLoginData(loginSchemaData);
  };

  const loadDefaults = () => {
    setStatus(false)
    setMessage('')
    props.closeDialog()
  }
  const submitProfile = async (event) => {
    event.preventDefault();
    let loginContent = [...loginData];
    let validFormData = await validateFormData(loginContent);
    setLoginData(validFormData)
    let result = validFormData.find(item => {
      if (item.error.length) return item;
    });


    if (!result) {
      setLoading(true)
      let params = await formToObj(validFormData);
      let { user } = props
      params.op = "setUser"
      params._id = user._id["$oid"]
      commons.getAPIRes(params, "POST", "user").then(userRes => {
        setLoading(false)
        setStatus(true)
        if (userRes.status) {
          setMessage(appMessages.userProfileSucMsg)
        }
        else
          setMessage(appMessages.userProfileFailMsg)
        setTimeout(function () {
          loadDefaults()
        }.bind(this), 2000)

        if (userRes.status) props.reloadPage()

      });
    }
    else {

    }
  };

  const handleChange = e => {
    let formDataInput = [...loginData];
    formDataInput.find(item => {
      if (item.key === e.target.name) {
        item.value = item.type === "number" ? parseInt(e.target.value) : e.target.value;
      }
    });
    setLoginData(formDataInput)
  };


  return (
    <>
      <Card>
        {loading ? <LinearProgress /> : false}
        <CardContent style={{ justifyContent: 'center' }}>
          <FormGenerator
            formList={loginData}
            editMode={true}
            onChange={handleChange}
          />

        </CardContent>
        <CardActions style={{ justifyContent: 'end' }}>
          <Button onClick={props.closeDialog} disabled={loading} style={{ ...customStyles.submitBtn }} >Cancel </Button>
          <Button onClick={submitProfile} disabled={loading} style={{ ...customStyles.submitBtn }} > Submit </Button>
        </CardActions>

      </Card>
      <SnackBarWidget status={status} message={message} />
    </>
  );
}

export default UserProfile;
